export const validateImage = async (file: File, type: 'profile' | 'logo' | 'post' | 'product' = 'post'): Promise<{ isValid: boolean; error?: string }> => {
  if (!file.type.startsWith('image/')) {
    return { isValid: false, error: 'O ficheiro deve ser uma imagem' };
  }

  // Profile photos and company logos only check file size
  if (type === 'profile' || type === 'logo') {
    if (file.size > 4 * 1024 * 1024) { // 4MB limit
      return { isValid: false, error: 'A imagem deve ter no máximo 4MB' };
    }
    return { isValid: true };
  }

  // For other images (posts, products, etc), check dimensions and 4MB size limit
  if (file.size > 4 * 1024 * 1024) {
    return { isValid: false, error: 'A imagem deve ter no máximo 4MB' };
  }

  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      if (img.width > 1800 || img.height > 1800) {
        resolve({ isValid: false, error: 'A imagem deve ter no máximo 1800x1800 pixels' });
      } else {
        resolve({ isValid: true });
      }
    };
    img.onerror = () => {
      resolve({ isValid: false, error: 'Erro ao carregar imagem' });
    };
    img.src = URL.createObjectURL(file);
  });
};